// Format a numeric client_id as QTR-NNN (zero-padded to 3 digits).
// If the backend already provides `client_code`, prefer that.
export function formatClientCode(idOrClient) {
  if (!idOrClient && idOrClient !== 0) return '-';
  // Allow passing the whole client object: formatClientCode(client)
  if (typeof idOrClient === 'object') {
    if (idOrClient.client_code) return idOrClient.client_code;
    return formatClientCode(idOrClient.client_id);
  }
  const digits = String(idOrClient).replace(/[^0-9]/g, '');
  if (!digits) return String(idOrClient);
  const n = parseInt(digits, 10);
  if (Number.isNaN(n)) return String(idOrClient);
  return `QTR-${String(n).padStart(3, '0')}`;
}
